import { View } from '@react-pdf/renderer'
import { PDFCard } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { FilterFieldsResponse } from 'shared/hooks/useFilterFields/useFilterFields'
import { GroupedFieldValues } from 'site/Renderer/components/FilterFields/types'
import PDFAreaLine from '../PDFAreaLine'
import FilterBody from './components/FilterBody/FilterBody'
import FilterHead from './components/FilterHead/FilterHead'
import getStyles from './styles'

interface FilterAreaProps {
  fields: FilterFieldsResponse
  values: GroupedFieldValues
  title: string
  composition: string
  filteractionName?: string
}

function FilterArea({
  fields,
  values,
  title,
  composition,
  filteractionName
}: FilterAreaProps) {
  const styles = getStyles()

  const { t } = useTranslation()

  const fieldByKey = Object.fromEntries(
    fields.classifiedFields.flat().map((field) => [field?.column_json, field])
  )

  const isFilterEmpty =
    Object.values(values).reduce<number>(
      (keysSum, group) => keysSum + Object.keys(group).length,
      0
    ) === 0

  if (isFilterEmpty) {
    return null
  }

  return (
    <View>
      <PDFAreaLine
        title={`${title} | ${t('filter-fields.filters')}`}
        backgroundColor='#0056CC'
      />
      <View style={styles.mainContainer}>
        <PDFCard style={styles.mainCard}>
          <View>
            <FilterHead
              isSingleGroup={true}
              composition={composition}
              filteractionName={filteractionName}
            />
          </View>
          {Object.entries(values).map(([key, value]) => (
            <FilterBody
              key={`filterbody-${key}`}
              fields={fieldByKey}
              values={value}
              filterName={`${t('report.filter-area.filter-head.filter-group')} ${key}`}
            />
          ))}
        </PDFCard>
      </View>
    </View>
  )
}

export default FilterArea
